/* eslint-disable no-unused-vars */

import { Get, Post, PostFormData } from "../Request";
export default {
  state: {
    TeamMembers: [],
    ViewTeamMember: null,
  },
  getters: {
    GetTeamMembers(state) {
      return state.TeamMembers;
    },
    GetViewTeamMember(state) {
      return state.ViewTeamMember;
    },
  },
  actions: {
    async GetTeamMembers({ commit }, payload) {
      return await Get(
        `TeamMember/getAllTeamMembers/${payload.page}?pageSize=${payload.pageSize}&search=${payload.search}`
      ).then((res) => {
        commit("SetTeamMembers", res.data.Data.List);
        return res.data.Data;
      });
    },
    async ValidateCode({ commit }, payload) {
      var Form = new FormData();
      Form.append("Code", payload);
      return await PostFormData(`TeamMember/ValidateCode`, Form).then((res) => {
        return res;
      });
    },
    async RegisterTeamMember({ commit }, payload) {
      return await Post("TeamMember/RegisterTeamMember", payload).then(
        (res) => {
          return res.data;
        }
      );
    },
    async EditTeamMember({ commit }, payload) {
      return await PostFormData("TeamMember/EditTeamMember", payload).then(
        (res) => {
          return res;
        }
      );
    },
    async DeleteTeamMember({ commit }, payload) {
      var form = new FormData();
      form.append("id", payload);
      return await Post("TeamMember/DeleteTeamMember", form).then((res) => {
        return res;
      });
    },
    async SendMailAgain({ commit }, payload) {
      var form = new FormData();
      form.append("id", payload);
      return await Post("TeamMember/SendMailAgain", form).then((res) => {
        return res;
      });
    },
    SetViewTeamMember({ commit }, payload) {
      commit("SetViewTeamMember", payload);
    },
  },
  mutations: {
    SetTeamMembers(state, payload) { 
      state.TeamMembers = payload;
    },
    SetViewTeamMember(state, payload) {
      state.ViewTeamMember = payload;
    },
  },
};
